<template>
   <div>
      <div class="container">
         <div class="wistia-block">
            <h1
               class="title"
               v-html="title" />
            <div id="wistia-wrapper">
               <wistia-player :video-id="videoId" />
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import { mapGetters } from 'vuex';
import WistiaPlayer from '@/components/WistiaPlayer';

export default {
   name: 'WistiaBlock',
   components: { WistiaPlayer },
   props: {
      title: {
         type: String,
         required: true,
      },
      videoId: {
         type: String,
         default: 'q7uqhigqf8',
      },
   },
   computed: {
      ...mapGetters(['height']),
   },
   methods: {
      visibilityChanged(visible, entry) {
         console.log('visibility changed', visible, entry);
      },
   },
};
</script>

<style lang="scss" scoped>
.wistia-block {
   display: flex;
   flex-flow: column nowrap;
   align-items: center;
   width: 100%;

   h1.title {
      //font-family: "Amaranth", sans-serif;
      //font-size: 270%;
      font-weight: bold;
      font-stretch: 100%;
      margin-top: 20px;
      text-align: center;
   }
   #wistia-wrapper {
      width: 100%;
      max-width: 600px;
      margin-top: 15px;
      margin-bottom: 30px;
   }
}
</style>
